(function () {
  'use strict';

  angular.module('eclipseApp.myAccount').controller('updatePaymentModalCtrl', ['$scope', '$http', '$q', 'data', 'uteEndpoint', 'commonService', 'dtmService', 'dtmServiceConstants', function ($scope, $http, $q, data, uteEndpoint, commonService, dtmService, dtmServiceConstants) {

    $scope.accountNumber = data.accountNumber;
    $scope.paymentStatus = 'confirm';
    $scope.MOPType = data.paymentType;
    $scope.contactEmail = data.contactEmail;
    $scope.paymentDetails = data;
    var subscriberCTN = '';
    var self = {};
    var selectedAccountDetail;
    var paymentMethod = {
      credit :  'C',
      chequing: 'D',
      invoice: 'R'
    };
    if ($scope.accountNumber) {

      selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
        return accountDetail.accountNumber === $scope.accountNumber
      });
    }


    if (selectedAccountDetail) {

      $scope.payment = {
        contactEmail : selectedAccountDetail.contactEmail,
        // accountBalance: selectedAccountDetail.balance,
        //date: selectedAccountDetail.paymentDueDate,
        hasWireless: selectedAccountDetail.hasWireless,
        MOPType : selectedAccountDetail.MOPType

      }
      $scope.contactEmail = $scope.payment.contactEmail;
    }
    if($scope.payment.hasWireless){
      $scope.account = "global.label.wireless";
      if(!(_.isEmpty(selectedAccountDetail.subscriberServices))){
        for(var i = 0; i<selectedAccountDetail.subscriberServices.length;i++){
          if(selectedAccountDetail.subscriberServices[i].wireless != null && selectedAccountDetail.subscriberServices[i].wireless.subscriberNo != null){
            subscriberCTN = selectedAccountDetail.subscriberServices[i].wireless.subscriberNo;
            break;
          }
        }
      }
    }
    else {
      if (commonService.customerHasTV) {
        $scope.account = "Internet/TV";
      } else {
        $scope.account = "Internet";
      }
    }


    var updatePaymentMethodUrl = '';

    if($scope.payment.hasWireless){
      updatePaymentMethodUrl = uteEndpoint('v1/wireless/updatePaymentMethod');
    }

    else{
      updatePaymentMethodUrl = uteEndpoint('v2/updatePaymentMethod');
    }


    console.log('@eclipseApp.myAccount: @data ', data);

    $scope.getLastDigits = function(number, type){
      var num = !_.isEmpty(number) ? number : '';
      if(angular.isDefined(number) && number.length > 4){
        if(type == paymentMethod.credit){ //retrieve last 4 digits
          num =  number.slice(-4);
        }else{
          num =  number.slice(0,1) + number.slice(-3); //retrieve first & last 3 digits
        }
      }
      return num;
    };

    $scope.updatePaymentMethod = function(){
      if(selectedAccountDetail && selectedAccountDetail.methodOfPaymentDetails){
        if(selectedAccountDetail.MOPType == "invoice"){
          selectedAccountDetail.methodOfPaymentDetails.moptype = paymentMethod.invoice ;
          selectedAccountDetail.methodOfPaymentDetails.creditCardDetails = null;
          selectedAccountDetail.methodOfPaymentDetails.chequingDetails = null;
        }else if(selectedAccountDetail.MOPType == "pacc"){
          var ccExpYear = $scope.paymentDetails.ccExpiryYear;
          ccExpYear = (ccExpYear.toString().length > 2 ) ? ccExpYear.toString().slice(2) : ccExpYear.toString() ;
          selectedAccountDetail.methodOfPaymentDetails.creditCardDetails = {
            ccNumber: $scope.getLastDigits($scope.paymentDetails.ccNumber, paymentMethod.credit),
            ccExpiry: ($scope.paymentDetails.ccExpiryMonth && ccExpYear) ? $scope.paymentDetails.ccExpiryMonth.toString() + ccExpYear : '',
            ccType: $scope.paymentDetails.ccType
          }
          selectedAccountDetail.methodOfPaymentDetails.moptype = paymentMethod.credit ;
          selectedAccountDetail.methodOfPaymentDetails.chequingDetails = null;
        }else if(selectedAccountDetail.MOPType == "pac"){
          selectedAccountDetail.methodOfPaymentDetails.chequingDetails = {
            accountNumber: $scope.getLastDigits($scope.paymentDetails.bankAccountNumber, paymentMethod.chequing),
            bankNumber: $scope.paymentDetails.bankCode,
            transitNumber: $scope.paymentDetails.transitCode
          }
          selectedAccountDetail.methodOfPaymentDetails.moptype = paymentMethod.chequing ;
          selectedAccountDetail.methodOfPaymentDetails.creditCardDetails = null;
        }
      }
    };

    var getUpdatePaymentData = function(data) {
      var deferred = $q.defer();

      if (data.paymentType == 'invoice') {
        deferred.resolve({
          mopType: data.paymentType,
          accountNumber: data.accountNumber,
          'chequingInfo.termsChecked': true,
          ctn:subscriberCTN,
          oldMopType:$scope.payment.MOPType
        });
      } else if (data.paymentType == 'pac') {
        deferred.resolve({
          mopType: data.paymentType,
          accountNumber: data.accountNumber,
          'chequingInfo.accountNumber': data.bankAccountNumber,
          'chequingInfo.bankNumber': data.bankCode,
          'chequingInfo.transitNumber': data.transitCode,
          'chequingInfo.termsChecked': true,
          ctn:subscriberCTN,
          oldMopType:$scope.payment.MOPType
        });
      } else if (data.paymentType === 'pacc') {
        if($scope.payment.hasWireless){
          //alert("inside 1if");
          if (data.ccExpiryMonth > 0 && data.ccExpiryMonth < 10) {
            data.ccExpiryMonth = '0' + data.ccExpiryMonth;
          }
        }
        //alert(data.ccExpiryMonth);
        deferred.resolve({
          mopType: data.paymentType,
          accountNumber: data.accountNumber,
          'CreditCardInfo.ccNumber': data.ccNumber,
          'CreditCardInfo.ccExpiryMonth': data.ccExpiryMonth,
          'CreditCardInfo.ccExpiryYear': data.ccExpiryYear,
          'CreditCardInfo.securityCode': data.cvv,
          'CreditCardInfo.ccType': data.ccType,
          'chequingInfo.termsChecked': true,
          ctn:subscriberCTN,
          oldMopType:$scope.payment.MOPType
        });
        //console.log('........................data...........', data);
        // uteCyberSource.getEncryptedToken(''+data.creditCardNumber).then(function (resp) {
        //   //console.log('........................ resp ...........', resp);
        //   var encrypted = resp.data;
        //   if (resp.data.rc === '100') {
        //     uteCyberSource.getDecryptedToken(encrypted, encrypted.cardType).success(function (resp) {
        //       //console.log('................ decrypt resp ..........', resp);
        //       if (resp.decrypt) {
        //         deferred.resolve({
        //           mopType: data.paymentType,
        //           'creditCardInfo.ccNumber': resp.decrypt,
        //           'creditCardInfo.ccExpiryMonth': data.expireMonth,
        //           'creditCardInfo.ccExpiryYear': data.expireYear,
        //           'creditCardInfo.securityCode': data.secruityCode,
        //           'creditCardInfo.ccType': data.ccType,
        //           'chequingInfo.termsChecked': true
        //         });
        //       } // if (data.decrypt)
        //     });
        //   }
        // }, function() {
        //   deferred.reject('Unexpected credit card encryption error');
        // }); // uteCyberSource
      } else {
        deferred.reject('Invalid payment type');
      }
      return deferred.promise;
    };

    $scope.updatePaymentOk = function () {
      $scope.paymentStatus = 'processing';

      getUpdatePaymentData(data).then(function(params) {
        $http({
          url: updatePaymentMethodUrl,
          method: 'POST',
          data: params
        }).success(function (data, status, headers, config) {
          console.log('data', data);
          if ((data.error || '')===''){
            selectedAccountDetail.MOPType = $scope.MOPType ;
            $scope.paymentStatus = 'accepted';
            $scope.updatePaymentMethod();
            dtmService.complete(dtmServiceConstants.dtmRules.updateMOP.name);
          } else if (data.error ==='60003'){
            $scope.paymentStatus = 'invalid-bank-details';
            var errorMessage = angular.isString(data.error) ? data.error || dtmServiceConstants.dtmRules.updateMOP.defaultServerError: dtmServiceConstants.dtmRules.updateMOP.defaultServerError;
            dtmService.fireDtmExceptions(dtmServiceConstants.dtmRules.updateMOP.name, [errorMessage], 'SS');
          } else {
            $scope.paymentStatus = 'error';
            dtmService.fireDtmExceptions(dtmServiceConstants.dtmRules.updateMOP.name, [dtmServiceConstants.dtmRules.updateMOP.defaultServerError], 'SS');
          }

        }).error(function (data, status, headers, config) {
          $scope.paymentStatus = 'error';
          dtmService.fireDtmExceptions(dtmServiceConstants.dtmRules.updateMOP.name, [dtmServiceConstants.dtmRules.updateMOP.defaultServerError], 'SS');
        });
      }, function(error) {
        console.log('update payment error', error);
        $scope.paymentStatus = 'error';
        dtmService.fireDtmExceptions(dtmServiceConstants.dtmRules.updateMOP.name, [dtmServiceConstants.dtmRules.updateMOP.defaultServerError], 'SS');
      });
    };

  }]);

})();
/*
      var _params;
      switch (data.paymentType) {
        case 'invoice': {
          _params = {
            mopType: data.paymentType,
            'chequingInfo.termsChecked': true
          };
          break;
        }
        case 'pacc': {
          uteCyberSource.getEncryptedToken(data.creditCardNumber).then(
            function (resp) {
              var encrypted = resp.data;
              if (encrypted.rc === '100') {
                uteCyberSource.getDecryptedToken(encrypted, encrypted.cardType).success(function (data) {
                  if (data.decrypt) {
                    $scope.payment.token = data.decrypt;

                    _params = {
                      mopType: data.paymentType,
                      'creditCardInfo.ccNumber': data.creditCardNumber,
                      'creditCardInfo.ccExpiryMonth': data.expireMonth,
                      'creditCardInfo.ccExpiryYear': data.expireYear,
                      'creditCardInfo.securityCode': data.secruityCode,
                      'creditCardInfo.ccType': data.ccType,
                      'chequingInfo.termsChecked': true
                    };


                  } else {
                    $scope.error = 'Invalid credit card - failed decryption';
                  }
                });
              } else {
                $scope.error = 'Invalid credit card - failed decryption';
              }
            }, function() {
              $scope.error = 'Unexpected credit card encryption error';
            }
          );

          _params = {
            mopType: data.paymentType,
            'creditCardInfo.ccNumber': data.creditCardNumber,
            'creditCardInfo.ccExpiryMonth': data.expireMonth,
            'creditCardInfo.ccExpiryYear': data.expireYear,
            'creditCardInfo.securityCode': data.secruityCode,
            'creditCardInfo.ccType': data.ccType,
            'chequingInfo.termsChecked': true
          };
          break;
        }
        case 'pac': {
          _params = {
            mopType: data.paymentType,
            'chequingInfo.bankNumber': data.bankCode,
            'chequingInfo.transitNumber': data.transitCode,
            'chequingInfo.termsChecked': true
          };
          break;
        }
        default: {
          _params = {
            mopType: data.paymentType,
            'chequingInfo.termsChecked': true
          };
        }
      }
      */
